/*
 * File: cache.ts
 * File Created: 2024-01-10 08:28:02
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-16 03:38:53
 * Modified By: Val Liu
 * -----
 */

import lodash from "lodash";
import { fastJSONStableStringify } from "../utilities";
import debug from "@/config/default/debug.js";

export function cache(milliseconds: number) {
    const cache = new Map<string, { result: any; timestamp: number }>();

    return function (
        target: any,
        propertyKey: string,
        descriptor: TypedPropertyDescriptor<(...args: any[]) => Promise<any>>,
    ) {
        const originalMethod = descriptor.value!;

        descriptor.value = async function (...args: any[]): Promise<any> {
            // hash and handle circular references
            const cacheKey = fastJSONStableStringify(args) ?? "";
            const now = Date.now();
            /// sanity check
            const cachedData = cache.get(cacheKey);
            const fresh = now - (cachedData?.timestamp ?? 0) < milliseconds;

            /// debugger /////////////////////
            debug.debugFormAndTable &&
                console.log(
                    `<@cache> key:`,
                    cacheKey,
                    ", data:",
                    cachedData,
                    ", fresh:",
                    fresh,
                );
            //////////////////////////////////

            // Check if cached result exists and is within the time threshold
            if (cachedData && fresh) {
                return cachedData.result;
            }
            // otherwise, delete the cache
            if (cachedData) cache.delete(cacheKey);

            // Call the original method and cache its result
            const result = originalMethod.apply(this, args);

            cache.set(cacheKey, { result, timestamp: now });

            return result;
        };

        return descriptor;
    };
}
